import { IWorkspaceSettingsRepository } from '../../domain/repositories/IWorkspaceSettingsRepository';
import { WorkspaceSettingsDTO } from '../dto/WorkspaceSettingsDTO';

/**
 * Use case for retrieving workspace settings
 */
export class GetWorkspaceSettingsUseCase {
  constructor(private readonly repository: IWorkspaceSettingsRepository) {}

  /**
   * Execute the use case to get workspace settings
   */
  async execute(workspaceId: number): Promise<WorkspaceSettingsDTO | null> {
    return this.repository.getSettings(workspaceId);
  }
}
